import { state } from './state';
import { ConfigModule } from './ConfigModule';


export * from './state/actions';
export * from './state/hooks';


export const config = {
    state,

    renderChain: [
        [ConfigModule, -35],
    ],
};
